// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const iron_jugulis: PokeData = {
  "id": 993,
  "name": "iron-jugulis",
  "height": 13,
  "weight": 1110,
  "base_experience": 285,
  "types": [
    PokeType.DARK,
    PokeType.FLYING
  ],
  "api_moves": [
    "roar",
    "hyper-beam",
    "focus-energy",
    "tri-attack",
    "outrage",
    "dragon-breath",
    "crunch",
    "knock-off",
    "hyper-voice",
    "air-cutter",
    "assurance",
    "dark-pulse",
    "air-slash",
    "dragon-pulse",
    "work-up",
    "snarl",
    "electric-terrain"
  ],
  "moves": [
    "tri-attack",
    "outrage",
    "dragon-breath",
    "crunch",
    "hyper-voice",
    "dark-pulse",
    "air-slash",
    "dragon-pulse",
    "snarl",
    "electric-terrain",
    "acrobatics",
    "peck",
    "gust"
  ],
  "evolution_chain": {
    "id": 524,
    "item": null,
    "species": [
      {
        "name": "iron-jugulis",
        "order": 990,
        "types": [
          PokeType.DARK,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 111,
    "speed": 136,
    "ability_power": 153
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
